import { motion } from "framer-motion";
import {
  Building2,
  IndianRupee,
  Database,
  Heart,
  RefreshCw,
  FileCheck,
  Users,
  Headphones,
} from "lucide-react";

const reasons = [
  { icon: Building2, title: "A professional corporate company built on trust and reliability" },
  { icon: IndianRupee, title: "No advance payment. Pay only after finalizing your caregiver" },
  { icon: Database, title: "A growing network of carefully vetted and trained professionals" },
  { icon: FileCheck, title: "Rigorous background checks and document verification for all staff" },
  { icon: Heart, title: "Ethical care focused on your family's comfort and satisfaction" },
  { icon: RefreshCw, title: "Hassle-free replacement support whenever required" },
  { icon: Users, title: "Personalized caregiving services with a human touch for every family" },
  { icon: Headphones, title: "Dedicated relationship managers for ongoing coordination" },
];

const item = {
  hidden: { opacity: 0, x: -20 },
  show: { opacity: 1, x: 0, transition: { duration: 0.35 } },
};

export default function WhyChooseUs() {
  return (
    <section id="why-us" data-testid="why-us-section" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-sm font-semibold text-[#14B8A6] uppercase tracking-wider font-body">
            Why CareCrony
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-semibold text-[#0F172A] tracking-tight mt-3">
            Why Choose Us
          </h2>
          <p className="text-base md:text-lg leading-relaxed text-[#64748B] mt-4 max-w-2xl mx-auto font-body">
            We go beyond just providing caregivers. Here's what sets us apart.
          </p>
        </div>

        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-50px" }}
          transition={{ staggerChildren: 0.08 }}
          className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-4xl mx-auto"
        >
          {reasons.map((reason, i) => (
            <motion.div
              key={i}
              variants={item}
              data-testid={`why-us-item-${i}`}
              className="flex items-center gap-4 p-5 rounded-2xl bg-[#F0FDFA] border border-[#14B8A6]/10 hover:border-[#14B8A6]/25 transition-colors"
            >
              <div className="w-10 h-10 rounded-xl bg-[#14B8A6]/15 flex items-center justify-center flex-shrink-0">
                <reason.icon className="w-5 h-5 text-[#14B8A6]" strokeWidth={1.5} />
              </div>
              <p className="text-sm font-medium text-[#0F172A] font-body leading-snug">
                {reason.title}
              </p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
